export default "__VITE_ASSET__CDVxGNcD__"